import { useMemo } from 'react';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';
import { ReportTab } from '@/modules/Reports/report.types';
import { DelinquentClaimsReportView } from '@/modules/Reports/ReportDetails/DelinquentClaimsReport/DelinquentClaimsReport.types';

const REPORT_VIEW_PARAMS = `tab=${ReportTab.Report}&reportView=${DelinquentClaimsReportView.ByEmployee}`;

const useGetDelinquentClaimsReportURL = () => {
  const {
    observingDefault: { id: defaultId, type: defaultType },
    observingOrganization: { id, type },
  } = useCurrentOrganization();

  const isEmployerObserving = useMemo(
    () => type === OrganizationTypes.employer || type === OrganizationTypes.company,
    [type]
  );

  const isEmployer = useMemo(
    () => defaultType === OrganizationTypes.employer || defaultType === OrganizationTypes.company,
    [defaultType]
  );

  const currentURL = useMemo(() => {
    if (isEmployerObserving) {
      return `${ROUTES.DELINQUENT_CLAIMS_REPORT}?${REPORT_VIEW_PARAMS}&employerId=${id}`;
    }
    if (isEmployer) {
      return `${ROUTES.DELINQUENT_CLAIMS_REPORT}?${REPORT_VIEW_PARAMS}&employerId=${defaultId}`;
    }
    return `${ROUTES.DELINQUENT_CLAIMS_REPORT}?${REPORT_VIEW_PARAMS}`;
  }, [defaultId, id, isEmployer, isEmployerObserving]);

  return currentURL;
};

export default useGetDelinquentClaimsReportURL;
